/* eslint-disable @typescript-eslint/no-explicit-any */
import { useHeaderContext } from '@/sinister/header/contexts/HeaderContext'
import { useGroupedPages } from '@mercadoni/sinister/dist/cjs/shared/hooks'
import { FC } from 'react'

interface MoreAboutLogicProps {
  Wrapper: FC<any>
}

const MoreAboutLogic: FC<MoreAboutLogicProps> = ({ Wrapper }) => {
  const { groupedPages } = useGroupedPages({
    position: 'header',
  })
  const { parsedHelpers = [] } = useHeaderContext()

  if (!groupedPages.length && !parsedHelpers.length) {
    return null
  }

  return <Wrapper />
}

export default MoreAboutLogic
